import type { LineageNodeData } from '@/types/lineage'
import { ACTIVE_COLOR } from '../constant'

interface LineageNodeProps {
  data: LineageNodeData
}

export const LineageNode = (props: LineageNodeProps) => {
  const { data } = props
  const isHovered = data.states?.includes('active')
  const isSelected = data.states?.includes('selected')
  const color = isHovered ? ACTIVE_COLOR : '#daf5eb36'

  const containerStyle = {
    width: '100%',
    height: '100%',
    background: '#0cf8a136',
    border: `2px solid ${color}`,
    borderRadius: 16,
    cursor: 'pointer',
    borderColor: color,
    color: '#000',
    fontSize: 14,
  }

  if (isSelected) {
    Object.assign(containerStyle, { border: `0px solid #000` })
  }

  return (
    <div style={containerStyle}>
      {data?.name}（{data?.id}）
    </div>
  )
}
